import { ModeItem } from './index.d';

export enum Mode {
  //0-省电模式 1-普通模式 2-精准模式 3-智能模式;
  saving = 0,
  normal = 1,
  intelligent = 2
}

export const modeList: ModeItem[]= [
  {
    value: Mode.saving,
    title: '省电模式',
    desc: '学生证每10分钟定位一次，比较省电'
  },
  {
    value: Mode.normal,
    title: '普通模式',
    desc: '学生证每5分钟定位一次，耗电一般'
  },
  {
    value: Mode.intelligent,
    title: '精准模式',
    desc: '学生证每2分钟定位一次，耗电较大'
  }
]


